/**
 * Tasks resource (CT-5722): the actions and human-in-the-loop tasks waiting on
 * a record, grouped act now / this week / later, and the four things a row can
 * do to itself (take over, complete, not now, dismiss).
 *
 * No contract has been shared yet: the paths are ASSUMED and marked
 * `TODO(CT-5722 / backend)`. Real signatures, snake_case bodies; only the
 * transport is stubbed. Search and the Type filter narrow on the server.
 */

import { validateApiResponse } from '../shared/utils/apiResponse.js';
import { request } from './mockTransport.js';

export { __resetMockTasksForTests, __setMockTasksScenario } from './__mocks__/tasks.mock.js';

/** The mutations a row can run, and the path each one posts to. */
const MUTATION_PATHS = Object.freeze({
  take_over: '/v0/profile/tasks/take-over',
  complete: '/v0/profile/tasks/complete',
  snooze: '/v0/profile/tasks/snooze',
  dismiss: '/v0/profile/tasks/dismiss',
});

/** Map one task row. Optional parts are `null`, never `''`, so an empty slot renders nothing. */
export const mapApiTaskToUi = (raw = {}) => ({
  id: raw.id ?? raw.task_id ?? raw.taskId ?? '',
  type: raw.type ?? null,
  title: raw.title ?? '',
  description: raw.description ?? null,
  owner: raw.owner
    ? { id: raw.owner.id ?? null, name: raw.owner.name ?? '', isMe: Boolean(raw.owner.is_me ?? raw.owner.isMe) }
    : null,
  hint: raw.hint ?? null,
  contextLine: raw.context_line ?? raw.contextLine ?? null,
  due: raw.due ? { kind: raw.due.kind ?? null, label: raw.due.label ?? '' } : null,
  action: raw.action ? { type: raw.action.type ?? null, ref: raw.action.ref ?? null } : null,
});

/**
 * TODO(CT-5722 / backend): `POST /v0/profile/tasks/list` with `{ entity_type,
 * entity_id, filters: { type }, search: { query, fields } }`.
 */
export const listTasks = async ({ entityType, entityId, filters, search } = {}) => {
  const response = await request('/v0/profile/tasks/list', {
    entity_type: entityType,
    entity_id: entityId,
    ...(filters ? { filters } : {}),
    ...(search ? { search } : {}),
  });
  return validateApiResponse(response, 'Failed to load the tasks');
};

/**
 * TODO(CT-5722 / backend): `POST /v0/profile/tasks/{take-over|complete|snooze|dismiss}`
 * with `{ entity_type, entity_id, task_id }`.
 */
export const runTaskMutation = async ({ entityType, entityId, taskId, mutation } = {}) => {
  const path = MUTATION_PATHS[mutation];
  if (!path) throw new Error(`Unknown task action ${mutation}`);
  const response = await request(path, { entity_type: entityType, entity_id: entityId, task_id: taskId });
  return validateApiResponse(response, 'Failed to update the task');
};
